export default "__VITE_ASSET__01299bf3__"